import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case02.creative-process-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem4Title: {
    id: `${PREFIX}.accordion-item4.title`,
  },
  accordionItem4Description: {
    id: `${PREFIX}.accordion-item4.description`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  collaboration: {
    id: `${PREFIX}.collaboration-info`,
  },
  bioJuliusTitle: {
    id: `${PREFIX}.bio.julius.title`,
  },
  bioJuliusDescription: {
    id: `${PREFIX}.bio.julius.description`,
  },
  bioJuliusLink: {
    id: `${PREFIX}.bio.julius.link`,
  },
  bioMichaelTitle: {
    id: `${PREFIX}.bio.michael.title`,
  },
  bioMichaelDescription: {
    id: `${PREFIX}.bio.michael.description`,
  },
  bioMichaelLink: {
    id: `${PREFIX}.bio.michael.link`,
  },
  bioAnaTitle: {
    id: `${PREFIX}.bio.ana.title`,
  },
  bioAnaDescription: {
    id: `${PREFIX}.bio.ana.description`,
  },
  bioAnaLink: {
    id: `${PREFIX}.bio.ana.link`,
  },
  bioDanielTitle: {
    id: `${PREFIX}.bio.daniel.title`,
  },
  bioDanielDescription: {
    id: `${PREFIX}.bio.daniel.description`,
  },
  bioDanielLink: {
    id: `${PREFIX}.bio.daniel.link`,
  },
  photoDescription1: {
    id: `${PREFIX}.photo-description.1`,
  },
  photoDescription2: {
    id: `${PREFIX}.photo-description.2`,
  },
});
